import { createContext } from 'preact';
import { Size } from '../../utils/UNSAFE_size';

/**
 * Props of the FormContext
 */
// TODO: investigate labelEdge, labelStartWidth, labelWrapping and see if they still need to be on the form components,
// or if we can just use a FormContext to pass this to a single component when it isn't in a form layout. See JET-51152
type FormContextProps = {
  /**
   * Indicates whether the form layout is disabled.
   */
  isDisabled?: boolean;
  /**
   * Indicates whether the component is inside a form layout.
   */
  isFormLayout?: boolean;
  /**
   * Indicates whether the form layout is readonly.
   */
  isReadonly?: boolean;
  /**
   * Specifies the label position.
   */
  labelEdge?: 'inside' | 'start' | 'top';
  /**
   * Specifies the width of the start aligned label, ignored for top aligned.
   */
  labelStartWidth?: Size;
  /**
   * Specifies if start or top label text should wrap or truncate.
   */
  labelWrapping?: 'truncate' | 'wrap';
  /**
   * Specifies the text alignment of the value.
   */
  textAlign?: 'start' | 'end' | 'right';
  /**
   * Specifies the density of the user assistance presentation.
   */
  userAssistanceDensity?: 'reflow' | 'efficient' | 'compact';
};

const DefaultFormContext: FormContextProps = {
  isDisabled: false,
  isFormLayout: false,
  isReadonly: false,
  labelEdge: 'inside',
  labelStartWidth: '33%',
  labelWrapping: 'wrap',
  textAlign: 'start',
  userAssistanceDensity: 'reflow'
};

/**
 * Context which the parent component can use to provide various FormLayout related
 * information to descendant form controls.
 */
const FormContext = createContext<FormContextProps>(DefaultFormContext);

export { DefaultFormContext, FormContext, FormContextProps };
